export default __webpack_public_path__ + "static/media/gamaz.bdc6c201.jpg";